import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/filerskeepers.webp';
import screenshot_target from '../../../images/letterfunnel/wannepemmelaar.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Wanne Pemmelaar"
      firstname="Wanne"
      companyname="Filerskeepers"
      competition="IRMS en Zasio"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/wannepemmelaar.js